
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import pageCom from "@/components/PageCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
import dialogCom from "@/components/ModelCom.vue";
import delCom from "@/components/DelDataCom.vue";
import { StoreTypes } from "@/assets/js/Types";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
export default Vue.extend({
  components: { action, pageCom, dialogCom, delCom },
  data() {
    return {
      delUrl: Urls.DelGroup,
      currentSid: "",
      items: [] as any[],
      total: 0,
      pageSize: 6,
      currentPage: 1,
      searchStr: null as any,
      dialogTitle: {
        title: "新增项目",
      },
      projectForm: {
        softwareGroupSids: [] as any,
        lightSensorPolicyActions: [] as any,
      } as any,
      current: null as any,
      groups: [] as any[],
      props: {
        label: "groupName",
        children: "children",
      },
      chooseGroups: [] as any,
      lightSensors: [] as any[],
    };
  },
  async mounted() {
    await this.select();
    await this.getGroups();
    await this.getLightSensors();
  },
  methods: {
    addTimmer() {
      this.projectForm.lightSensorPolicyActions.push({
        sid: Utils.GetGuid(),
        startValue: 0,
        endValue: 0,
        lightRate: 100,
      });
    },
    removeTimmer(sid: string) {
      let index = -1;
      for (let i = 0; i < this.projectForm.lightSensorPolicyActions.length; i++) {
        if (this.projectForm.lightSensorPolicyActions[i].sid == sid) {
          index = i;
        }
      }
      this.projectForm.lightSensorPolicyActions.splice(index, 1);
    },
    async getLightSensors() {
      const ret: any = await DeviceRequestBill.GetLightSensors(null, 1, 100);
      this.lightSensors = ret.data;
    },
    async getGroups() {
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetSoftGroups, 0, true, false);
      this.groups = [
        {
          groupName: "根目录",
          sid: null,
          children: ret,
        },
      ];
    },
    checkChanged() {
      const tree: any = this.$refs.groupTree;
      const list = tree.getCheckedNodes();
      this.chooseGroups = [];
      list.forEach((ele: any) => {
        this.chooseGroups.push(ele.sid);
      });
    },
    async select() {
      const actionBar: any = this.$refs.action;
      this.searchStr = actionBar.getSearch();
      if (Utils.StringIsNull(this.searchStr)) {
        this.searchStr = null;
      }
      const ret = await DeviceRequestBill.GetLightSensorPolicys(
        this.searchStr,
        this.currentPage,
        this.pageSize
      );
      this.items = ret.data;
      this.total = ret.total;
    },
    currentChange(val: any) {
      this.current = val;
    },
    insert() {
      this.current = null;
      this.projectForm = {
        sid: null,
        softwareGroupSids: [] as any,
        lightSensorPolicyActions: [] as any,
      };
      this.dialogTitle.title = "新增策略";
      const dialog: any = this.$refs.projectDialog;
      dialog.show();
    },
    closeDialog() {
      const dialog: any = this.$refs.projectDialog;
      dialog.hiden();
    },
    async modify() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      const ret: any = await HttpUtil.XCHttpPost(
        Urls.GetLightSensorPolicy,
        this.current.sid,
        true,
        false
      );
      this.projectForm = ret;
      this.chooseGroups = this.projectForm.softwareGroupSids;
      this.dialogTitle.title = "修改策略";
      const dialog: any = this.$refs.projectDialog;
      dialog.show();
    },
    opened() {
      const tree: any = this.$refs.groupTree;
      if (this.chooseGroups && this.chooseGroups.length > 0) {
        try {
          tree.setCheckedKeys(this.chooseGroups);
        } catch {
          //
        }
      }
    },
    del() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.currentSid = this.current.sid;
      const dialog: any = this.$refs.del;
      dialog.show();
    },
    ex() {
      //
    },
    inport() {
      //
    },
    search() {
      this.select();
    },
    searchChanged(str: string) {
      this.searchStr = str;
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.select();
    },
    async onSubmit() {
      this.projectForm.softwareGroupSids = this.chooseGroups;
      if (!this.projectForm.sid) {
        await HttpUtil.XCHttpPost(
          Urls.AddLightSensorPolicy,
          this.projectForm,
          true,
          false
        );
      } else {
        await HttpUtil.XCHttpPost(
          Urls.UpdateLightSensorPolicy,
          this.projectForm,
          true,
          false
        );
      }
      this.closeDialog();
      this.select();
    },
  },
});
